import React from 'react'
import Navbar from '../components/Navbar/Navbar';
import FormMe from '../components/Form/FormMe';
import FooterMe from '../components/Footer/FooterMe';
import 'flowbite'
const Form = () => {
  return (
    <>
    <Navbar />
    <FormMe />
    <FooterMe />
    </>
  )
}

export default Form